<!--suppress ALL -->
<template>
  <v-container flat>
    <v-layout justify-center row>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-card-title>
            <span class="title">用户信息注册</span>
          </v-card-title>
          <v-layout>
            <v-flex xs12>
              <v-select
                label="用户类型"
                prepend-icon="$vuetify.icons.group"
                v-model="form.type"
                :items="form.typeSelect"
                item-text="name"
                item-value="value"
                :disabled="disabledFlag"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-form
            ref="form1"
            v-if="form.type === 'portal' || form.type === 'chengjiao'"
          >
            <v-layout column>
              <v-flex xs12>
                <v-text-field
                  label="姓名"
                  prepend-icon="$vuetify.icons.person"
                  v-model="form.name"
                  :rules="[$rules.requiredS()]"
                  :disabled="disabledFlag"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :label="transType(form.type)"
                  prepend-icon="mdi-account-card-details"
                  v-model="form.loginId"
                  :rules="[$rules.requiredS()]"
                  :disabled="disabledFlag"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="form.type == 'chengjiao'">
                <v-text-field
                  label="手机号"
                  prepend-icon="mdi-phone"
                  v-model="form.phone"
                  :rules="[$rules.requiredS()]"
                  :disabled="disabledFlag"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="form.type != 'chengjiao'">
                <v-text-field
                  label="密码"
                  prepend-icon="mdi-lock"
                  v-model="form.password"
                  :hint="passwordHint"
                  persistent-hint
                  :rules="[$rules.requiredS()]"
                  type="password"
                  :disabled="disabledFlag"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <v-form ref="visitorForm" v-else-if="form.type === 'visitor'">
            <v-layout row wrap>
              <v-flex xs12 class="py-1">
                <v-text-field
                  :rules="$rules.phone11()"
                  label="联系电话"
                  placeholder="请输入联系电话"
                  prepend-icon="mdi-phone"
                  v-model="form.phone"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-text-field
                  class="pb-1"
                  single-line
                  label="验证码"
                  type="number"
                  placeholder="请输入验证码"
                  prepend-icon="$vuetify.icons.code"
                  v-model="verifyObj.verifyCode"
                  :disabled="disabledFlag === true"
                  :error-messages="
                    disabledFlag === true ? '' : verifyObj.errorMessage
                  "
                ></v-text-field>
              </v-flex>
              <div v-if="pictureVerifyFlag === true">
                <v-btn
                  flat
                  color="primary"
                  @click="
                    getTmpToken();
                    verifyObj.getFlag = true;
                  "
                  :disabled="disabledFlag === true"
                  v-if="verifyObj.expire <= 0"
                >
                  <span v-if="!verifyObj.getFlag">获取短信验证码</span>
                  <span v-else>重新获取</span>
                </v-btn>
                <span v-else style="font-size: 16px"
                  >{{ verifyObj.expire }}s</span
                >
              </div>
              <div v-else>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    getTmpToken('picture');
                    verifyObj.getFlag = true;
                  "
                  :disabled="disabledFlag === true"
                  v-if="verifyObj.expire <= 0"
                >
                  <span v-if="!verifyObj.getFlag">获取验证码</span>
                  <span v-else>重新获取</span>
                </v-btn>
                <span v-else style="font-size: 16px"
                  >{{ verifyObj.expire }}s</span
                >
              </div>
            </v-layout>
            <div v-if="verifyObj.pic !== ''">
              <img :src="`data:image/png;base64,${verifyObj.pic}`" />
            </div>
          </v-form>
          <v-form ref="form2" v-else>
            <v-layout column>
              <v-flex xs12>
                <v-text-field
                  label="姓名"
                  prepend-icon="$vuetify.icons.person"
                  v-model="form.name"
                  :rules="[$rules.requiredS()]"
                  :disabled="disabledFlag"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="手机号"
                  prepend-icon="$vuetify.icons.phone"
                  v-model="form.phone"
                  :rules="$rules.phone11()"
                  type="number"
                  :disabled="disabledFlag"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout justify-center style="margin-top: 20px">
            <v-btn
              class="primary"
              @click="submit"
              :loading="loading"
              :disabled="
                disabledFlag ||
                (form.type === 'visitor' && verifyObj.verifyCode === '')
              "
              >数据验证</v-btn
            >
            <v-btn
              class="primary"
              v-if="form.type === 'portal'"
              @click="resetPassword"
              >忘记密码</v-btn
            >
            <v-btn
                class="primary"
                v-if="form.type === 'portal'"
                @click="activeAccount"
            >账号激活</v-btn
            >
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "bindWx",
  data() {
    return {
      disabledFlag: false,
      jsCode: "",
      passwordHint:
        "学校统一身份认证密码，新用户首次登录统一身份认证需自助激活账号设置密码。 ",
      form: {
        typeSelect: [
          { name: "教师|学生", value: "portal" },
          { name: "继教用户", value: "chengjiao" },
          { name: "合作用户", value: "cooperate" },
          { name: "访客用户", value: "visitor" },
          { name: "校友用户", value: "graduated" },
          { name: "留学预教用户", value: "preabroad" },
        ],
        type: "portal",
        name: "",
        password: "",
        loginId: "",
        phone: "",
      },
      verifyObj: {
        show: false,
        getFlag: false,
        expire: 0,
        key: "",
        verifyCode: "",
        verifyKey: "",
        errorMsg: "",
        checkStatus: false,
        pic: "",
        premsg: "",
      },
      pictureVerifyFlag: false,
      loading: false,
      disabledFlag: false,
    };
  },
  created() {
    this.jsCode = this.$route.query.code;
  },
  methods: {
    resetPassword() {
      const aim = this.$route.query.aim;
      const url = "https://idas.uestc.edu.cn/retrieve-password/passwordMobile/index.html#/home";
        // "https://idas.uestc.edu.cn/authserver/getBackPasswordMainPage.do?service=" +
        // window.encodeURI(
        //   `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=https://smaco2.uestc.edu.cn/wx/autoLogin?aim=${aim}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`
        // );
      window.location.href = url;
    },

    activeAccount() {
      const aim = this.$route.query.aim;
      const url = "https://idas.uestc.edu.cn/retrieve-password/activationMobile/index.html#/home";
      // "https://idas.uestc.edu.cn/authserver/getBackPasswordMainPage.do?service=" +
      // window.encodeURI(
      //   `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=https://smaco2.uestc.edu.cn/wx/autoLogin?aim=${aim}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`
      // );
      window.location.href = url;
    },
    transType(type) {
      switch (type) {
        case "portal":
          return "教工号|学号";
          break;
        case "chengjiao":
          return "注册号";
          break;
        default:
          return "学号";
          break;
      }
    },
    checkForm() {
      if (this.form.type === "portal" || this.form.type === "chengjiao") {
        if (this.$refs.form1.validate()) {
          return true;
        } else {
          this.$L.alert("error", { message: "表单数据错误" });
        }
      } else {
        if (this.$refs.form2.validate()) {
          return true;
        } else {
          this.$L.alert("error", { message: "表单数据错误" });
        }
      }
    },
    async submit() {
      if (this.form.type === "visitor") {
        this.visitorSubmit();
        return;
      }
      if (this.checkForm()) {
        let extend = {
          username: this.form.loginId,
          passwd: this.form.password,
        };
        let param = {
          name: this.form.name,
          type: this.form.type,
          code:
            this.form.type === "portal" || this.form.type === "chengjiao"
              ? this.form.loginId
              : this.form.phone,
          phone: this.form.phone,
          org: "",
          gender: "",
          age: "",
          extend:
            this.form.type === "portal" || this.form.type === "chengjiao"
              ? JSON.stringify(extend)
              : "",
        };
        let res = await this.$store.dispatch("wx/checkData", param);
        if (res.data.status === 1) {
          this.$L.alert("success", { message: "验证成功" });
          let query = {
            phone: res.data.data.msg,
            key: res.data.data.hashKey,
            jsCode: this.jsCode || "",
            aim: this.$route.query.aim,
            type: this.form.type,
          };
          if (this.$route.query.backUrl !== undefined) {
            query.backUrl = this.$route.query.backUrl;
          }
          this.$router.push({ name: "parse", query: query });
          this.disabledFlag = true;
        } else {
          if (this.form.type === "chengjiao") {
            this.$L.alert("error", {
              message: "预留信息有误，更新请联系继教院!",
            });
          } else {
            this.$L.alert("error", {
              message: "验证失败，原因：" + res.data.msg,
            });
          }
        }
      }
    },
    async visitorSubmit() {
      if (this.$refs.visitorForm.validate()) {
        if (!this.pictureVerifyFlag) {
          await this.checkCode();
          return;
        } else {
          this.loading = true;
          let checkRes = await this.checkCode();
          if (checkRes) {
            try {
              let param = {
                type: this.form.type,
                verifyKey: this.verifyObj.verifyKey,
                username: "",
                password: "",
              };
              let res = await this.$store.dispatch("wx/bindUser", {
                param: param,
                jsCode: this.jsCode,
                phone: this.form.phone,
              });
              if (res.data.status === 1) {
                this.$L.alert("success", { message: "注册成功" });
                let aim = this.$route.query.aim;
                if (
                  aim.indexOf("selfSign") !== -1 ||
                  aim.indexOf("personSelfSign") !== -1
                ) {
                  let redirectUrl =
                    "https://smaco2.uestc.edu.cn/wx/autoLogin?aim=" + aim;
                  window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
                } else {
                  let redirectUrl =
                    "https://smaco2.uestc.edu.cn/wx/autoLogin?aim=" + aim;
                  window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
                }
              } else {
                this.$L.alert("error", { message: res.data.msg });
                setTimeout(function () {
                  let aim = this.$route.query.aim;
                  let redirectUrl =
                    "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
                  window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
                }, 5 * 1000);
              }
            } catch (e) {
            } finally {
              this.loading = false;
              this.disabledFlag = true;
            }
          } else {
            this.loading = false;
          }
        }
      }
    },
    async getTmpToken(type = "msg") {
      if (!this.$refs.visitorForm.validate()) {
        this.$L.alert("error", { message: "表单数据有误" });
        return;
      }
      this.verifyObjReset();
      let res = await this.$store.dispatch(
        "letterReservation/selfSign_getTmpToken"
      );
      if (res.data.status === 1) {
        this.verifyObj.expire = 60;
        this.verifyObj.key = res.data.data.key;
        this.sendVertifyMessage(type);
      } else {
        this.$L.alert("error", { message: res.data.msg });
      }
    },
    async sendVertifyMessage(type) {
      if (type === "msg") {
        let res = await this.$store.dispatch(
          "letterReservation/selfSign_getVerifyMsg",
          {
            key: this.verifyObj.key,
            phone: this.form.phone,
            hash: this.verifyObj.premsg,
          }
        );
        if (res.data.status === 1) {
          this.verifyObj.verifyKey = res.data.data.verifyKey;
        } else {
          this.$L.alert("error", { message: res.data.msg });
        }
      } else {
        let res = await this.$store.dispatch(
          "letterReservation/selfSign_getVerifyMsgPic",
          { key: this.verifyObj.key }
        );
        if (res.data.status === 1) {
          this.verifyObj.verifyKey = res.data.data.verifyKey;
          this.verifyObj.pic = res.data.data.verify;
          this.verifyObj.premsg = res.data.data.premsg;
        } else {
          this.$L.alert("error", { message: res.data.msg });
        }
      }
    },
    async checkCode() {
      this.disabledFlag = true;
      let config = {
        verifyKey: this.verifyObj.verifyKey,
        realMsg: this.verifyObj.verifyCode,
        premsg: this.verifyObj.premsg,
      };
      let res = await this.$store.dispatch(
        "letterReservation/selfSign_checkVerify",
        config
      );
      if (res.data.status === 1) {
        this.verifyObjReset();
        if (!this.pictureVerifyFlag) {
          this.pictureVerifyFlag = true;
          this.disabledFlag = false;
          this.getTmpToken();
        }
        return true;
      } else {
        this.$L.alert("error", { message: res.data.msg });
        this.disabledFlag = false;
        this.verifyObj.expire = -1;
        this.verifyObj.errorMsg = res.data.msg + ",请重新获取";
        return false;
      }
    },
    verifyObjReset() {
      this.verifyObj.show = false;
      this.verifyObj.getFlag = false;
      this.verifyObj.verifyCode = "";
      this.verifyObj.errorMsg = "";
      this.verifyObj.expire = 0;
      this.verifyObj.pic = "";
    },
  },
  watch: {
    "verifyObj.expire"(val, oldVal) {
      if (val > 0) {
        if (val > oldVal) {
          setTimeout(() => {
            this.verifyObj.expire = val - 1;
          }, 1000);
        } else {
          setTimeout(() => {
            this.verifyObj.expire -= 1;
          }, 1000);
        }
      } else if (val === 0) {
        this.verifyObj.errorMessage = "验证码已过期，请重新获取";
      } else {
      }
    },
    "verifyObj.verifyCode"() {
      // console.log('change')
      this.verifyObj.errorMessage = "";
    },
  },
};
</script>
